import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { config, Font } from '../../constants'
import { storeInSessionCache } from '../../modules/cache'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'

Locale.getInstance().registerKeySet('fr', 'lvc-become-partner-button', {
  becomePartner: "S'inscrire comme partenaire",
  isPartnerProcess: "Soumis et en attente d'approbation",
  isPartner: "Accéder à l'Espace Pro",
})

Locale.getInstance().registerKeySet('en', 'lvc-become-partner-button', {
  becomePartner: 'Become a partner',
  isPartnerProcess: 'Submitted and awaiting approval',
  isPartner: 'Access my Pro Space',
})

export interface LvcBecomePartnerButton {
  title: string
  placeholder: string
  open: boolean
  onChange: string
  defaultValue: any
  value: string
}

export class LvcBecomePartnerButton extends MinzeElement {
  private regions: any[] = []
  private selectedIds: string[] = []
  private filter: string = ''
  attrs: Attrs = ['title', 'data-text']

  reactive: Reactive = [
    ['value', ''],
    ['buttonHref', ''],
  ]

  static observedAttributes = ['title', 'on-change']

  private isLoggedIn: boolean = false
  private isPartner: boolean = false
  private isPartnerProcess: boolean = false

  async onReady() {
    const mainModule = MainModule.getInstance()

    // get user connection status
    this.isLoggedIn = await mainModule.getAuth().isLoggedIn()

    mainModule.getEE().on('lvc:user_state_changed', async () => {
      this.isLoggedIn = await MainModule.getInstance().getAuth().isLoggedIn()
      this.updateButtonHref()
    })

    this.updateButtonHref()
  }

  async onRender() {
    const mainModule = MainModule.getInstance()

    this.isPartner = await mainModule.getAuth().isPartner()
  }

  updateButtonHref() {
    const mainModule = MainModule.getInstance()
    const router = mainModule.getRouting()
    const registerRoute = router.getRoute('signup')
    const partnerRegisterRoute = router.getRoute('partnerRegister')
    const lang = mainModule.getLang() as 'fr' | 'en'
    const partnerDashboardRoute = config.proSpaceUrl[lang]

    // if you are not logged in, you are not a partner
    if (!this.isLoggedIn) {
      this.isPartner = false
      this.isPartnerProcess = false
      this.buttonHref = registerRoute
      return
    }
    // if you are logged in, check if you are a partner or in the process of becoming one
    if (this.isLoggedIn) {
      let profile = mainModule.getAuth().getUserData()
      this.buttonHref = partnerRegisterRoute

      if (profile.profile.becomePartnerProcessStarted) {
        this.isPartnerProcess = true
      }
      if (profile.profile.becomePartnerProcessFinished) {
        this.isPartner = true
        this.buttonHref = partnerDashboardRoute
      }
    }
    this.rerender()
  }

  updateButtonText() {
    // This function sets the button text depending on user connection status
    if (this.isPartnerProcess && !this.isPartner) {
      return Locale.getKey('lvc-become-partner-button.isPartnerProcess')
    } else if (this.isPartner) {
      return Locale.getKey('lvc-become-partner-button.isPartner')
    } else {
      return Locale.getKey('lvc-become-partner-button.becomePartner')
    }
  }

  // Track the button click
  async trackPartnerButtonClick() {
    await MainModule.getInstance().analyticsTrack('cta_pro_sign_up', {
      emplacement: 'page_pro',
    })
  }

  onPartnerButtonClick() {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    if (!this.isPartner) {
      storeInSessionCache('partnerSignupProcessTriggered', true)
    }
    // redirect to whatever the button href is
    routing.goTo(this.buttonHref as string)
  }

  html = () => {
    return `

    <lvc-box display="flex" justifyContent="center">
        <lvc-button
        name="becomePartner"
        width="fit-content"
        border="1px solid #1E007D"
        color="#fff"
        border-radius="999px"
        display="flex"
        align-items="center"
        justify-content="center"
        font-weight=${Font.weight.medium}
        padding="14px 24px"
        height="52px"
        disabled=${this.isPartnerProcess ? 'true' : 'false'}
        >
        ${this.dataText ? this.dataText : this.updateButtonText()}
        </lvc-button>
    </lvc-box>

    `
  }

  css = () => {
    return `
      :host {
      }

    `
  }

  eventListeners: EventListeners = [
    [
      'lvc-button[name="becomePartner"]',
      'click',
      () => {
        this.trackPartnerButtonClick()
        this.onPartnerButtonClick()
      },
    ],
  ]
}
